import { render, staticRenderFns } from "./smd-navigation.vue?vue&type=template&id=4a20daeb&"
import script from "./smd-navigation.vue?vue&type=script&lang=js&"
export * from "./smd-navigation.vue?vue&type=script&lang=js&"
import style0 from "./smd-navigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports